export default __webpack_public_path__ + "static/media/Error.b4e94191.mp3";